import { QueryProvider } from '@/app/providers/QueryProvider';
import { router } from '@/app/router';
import { ConfirmDialogProvider } from '@/shared/components/ConfirmDialogProvider';
import { VersionUpdateBanner } from '@/shared/components/VersionUpdateBanner';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from 'sonner';

function App() {
  return (
    <QueryProvider>
      <ConfirmDialogProvider>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
        {/* 레거시 _app.js: version.json 변경 시 새로고침 유도 */}
        <VersionUpdateBanner />
      </ConfirmDialogProvider>
    </QueryProvider>
  );
}

export default App;
